import React, { useState, useEffect } from 'react';
import './PhotoSelector.css';
import photoboothIcon from '../img/photobooth.png';

interface Photo {
  id: string;
  dataUrl: string;
}

interface PhotoSelectorProps {
  onSelectPhoto?: (photoUrl: string) => void;
  onClose: () => void;
  onOpenPhotoBooth?: () => void;
  onOpenPreview?: (photoUrl: string, photoId: string) => void;
  mode?: 'select' | 'browse';
}

const PhotoSelector: React.FC<PhotoSelectorProps> = ({
  onSelectPhoto,
  onClose,
  onOpenPhotoBooth,
  onOpenPreview,
  mode = 'select'
}) => {
  const [photos, setPhotos] = useState<Photo[]>([]);

  useEffect(() => {
    // Load photos from localStorage
    try {
      const saved = localStorage.getItem('photoboothPhotos');
      if (saved) {
        const parsedPhotos = JSON.parse(saved);
        console.log('Garden App - Loaded photos:', parsedPhotos);
        setPhotos(parsedPhotos);
      }
    } catch (error) {
      console.error('Error loading photobooth photos:', error);
    }
  }, []);

  const handlePhotoClick = (photo: Photo) => {
    if (mode === 'browse' && onOpenPreview) {
      onOpenPreview(photo.dataUrl, photo.id);
    } else if (mode === 'select' && onSelectPhoto) {
      onSelectPhoto(photo.dataUrl);
    }
  };

  return (
    <div className="photo-selector-overlay" onClick={onClose}>
      <div className="photo-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="photo-selector-header">
          <div className="photo-selector-header-content">
            <h3>Select a Photo</h3>
            <p className="photo-selector-subtitle">
              Tap the + button to take photos in Photobooth, and they'll show up here!
            </p>
          </div>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="photo-grid-container">
          {photos.length === 0 ? (
            <div className="no-photos-message">
              <p>No photos found. Take some in Photo Booth first!</p>
              <button
                className="snap-photo-button"
                onClick={() => {
                  onClose();
                  onOpenPhotoBooth?.();
                }}
              >
                <img src={photoboothIcon} alt="Photo Booth" className="snap-photo-icon" />
                <span>Snap a Photo</span>
              </button>
            </div>
          ) : (
            <div className="photo-grid">
              {photos.map((photo) => (
                <img
                  key={photo.id}
                  src={photo.dataUrl}
                  alt={`Photo ${photo.id}`}
                  className="photo-thumbnail"
                  onClick={() => handlePhotoClick(photo)}
                />
              ))}
              {/* Add Photobooth tile */}
              <div
                className="add-photo-tile"
                onClick={() => {
                  onClose();
                  onOpenPhotoBooth?.();
                }}
              >
                <div className="add-photo-plus">+</div>
                <img src={photoboothIcon} alt="Photo Booth" className="add-photo-icon" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhotoSelector;
